export default __webpack_public_path__ + "static/media/adModalImg.3cda335a.png";